// src/pages/NotFoundPage.js

import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function NotFoundPage() {
    const navigate = useNavigate();

    const handleSearchMore = () => {
        navigate('/listings');
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
            <Box sx={{ mb: 4 }}>
                <Typography variant="h3" gutterBottom>
                    Oops! Listing Not Found
                </Typography>
                <Typography variant="body1">
                    We couldn’t find that listing—maybe it’s been removed or is no longer available.
                </Typography>
            </Box>
            <Button variant="contained" color="primary" onClick={handleSearchMore}>
                Search for More Listings
            </Button>
        </Container>
    );
}

export default NotFoundPage;
